module.exports = __webpack_public_path__ + "img/alert-triangle.ae89eeac.svg";